// Полифилл для process (для библиотек, которые используют process напрямую)
// В Create React App webpack должен заменять process.env на реальные значения,
// но некоторые библиотеки могут использовать process напрямую
if (typeof process === 'undefined') {
  // Определяем NODE_ENV из режима сборки
  const nodeEnv = (typeof window !== 'undefined' && window.__NODE_ENV__) || 'development';
  const apiUrl = (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__.REACT_APP_API_URL) 
    || 'http://localhost:6060';
  
  window.process = {
    env: {
      NODE_ENV: nodeEnv,
      REACT_APP_API_URL: apiUrl,
    },
  };
}

